import { WebStorageStateStore } from 'oidc-client-ts'
import type { AuthProviderProps } from 'react-oidc-context'
import { env } from './env'

/**
 * SPA-managed PKCE flow (see ADR-002). We use sessionStorage for the user object
 * so a tab refresh doesn't bounce through Keycloak; tokens themselves still live
 * in memory. Logout clears both and redirects to Keycloak's end-session endpoint.
 */
export const oidcConfig: AuthProviderProps = {
  authority: env.VITE_OIDC_AUTHORITY,
  client_id: env.VITE_OIDC_CLIENT_ID,
  redirect_uri: env.VITE_OIDC_REDIRECT_URI,
  post_logout_redirect_uri: env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI,
  response_type: 'code',
  scope: 'openid profile email',
  loadUserInfo: true,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  // Strip the OIDC ?code=...&state=... params from the URL after the callback
  // so the user's address bar shows / not /?code=...
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname)
  },
}
